import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportsSettingsDrawer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 18,
	viewBox: "0 0 23 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 4,
			height: 4,
			transform: "translate(9.5)",
			fill: "#4A209C"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4,
			height: 4,
			transform: "translate(9.5 7)",
			fill: "#4A209C"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4,
			height: 4,
			transform: "translate(9.5 14)",
			fill: "#4A209C"
		})
	]
});
const ForwardRef = forwardRef(SvgReportsSettingsDrawer);
export { ForwardRef as ReactComponent };
